/**
 * Private-use character: splits confirmation modal body into primary text + optional secondary block
 * (e.g. Profit Plus manual-delete notice). Won’t appear in normal user-facing copy.
 */
export const CONFIRMATION_SECONDARY_BLOCK_DELIMITER = '\uE000';

export function parseConfirmationBodyWithOptionalSecondary(message: string): {
  primary: string;
  secondary?: string;
} {
  if (!message.includes(CONFIRMATION_SECONDARY_BLOCK_DELIMITER)) {
    return { primary: message };
  }
  const parts = message.split(CONFIRMATION_SECONDARY_BLOCK_DELIMITER);
  const primary = parts[0]?.trimEnd() ?? '';
  const secondary = parts
    .slice(1)
    .join(CONFIRMATION_SECONDARY_BLOCK_DELIMITER)
    .trim();
  return {
    primary,
    secondary: secondary || undefined,
  };
}
